import { render, staticRenderFns } from "./LaunchPad.vue?vue&type=template&id=54c00404&"
import script from "./LaunchPad.vue?vue&type=script&lang=js&"
export * from "./LaunchPad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports